// Switch selected tab on click

[...document.querySelectorAll('.tabs')].forEach((tabGroup) => {
  const tabs = [...tabGroup.querySelectorAll('.tabs__content')];
  const toggles = [...tabGroup.querySelectorAll('.tabs__toggle button')];
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      // On toggle click, deactivate all toggles and tabs
      [...toggles, ...tabs].forEach(toggle => toggle.classList.remove('active'));
      // And activate this toggle and its tab
      [...tabs.filter(tab => tab.getAttribute('data-tab-handle') === toggle.getAttribute('data-tab-handle')),
        toggle].forEach(el => el.classList.add('active'));
    });
  });
});
